<template>
    <div>
        <!-- P R O D U C T -->
        <template v-if="hovertype === 'PRODUCT'">
            <NuxtLink :to="`/products/${hoverItem.handle}`">
                <transition name="fade-in">
                    <MenuHoverImage :src="hoverItem.featuredImage.url" :alt="hoverItem.shortDescription.value" :imagetype="hovertype.toLowerCase()"/>
                </transition>
                <p class="mt-6">
                    {{hoverItem.shortDescription.value}}
                </p>
            </NuxtLink>
        </template>
        <!-- C O L L E C T I O N -->
        <template v-if="hovertype === 'COLLECTION'">
            <NuxtLink :to="`/shop/${hoverItem.handle}`">
                <transition name="fade-in">
                    <MenuHoverImage  :src="hoverItem.image.url" :alt="hoverItem.description" :imagetype="hovertype.toLowerCase()"/>
                </transition>
            </NuxtLink>
            <p class="mt-6">
                {{hoverItem.description}}
            </p>
        </template>
        <!-- A R T I C L E -->
        <template v-if="hovertype === 'ARTICLE'">
            <NuxtLink :to="url">


                    <MenuHoverMediaImage v-if="hoverItem.coverImage" :mediaData="hoverItem.coverImage.reference" :alt="hoverItem.title" :imagetype="hovertype.toLowerCase()"/>
                    <UiArticleImage v-else :article="{ title: hoverItem.title, image: hoverItem.image.src}"
                        :modifiers="{
                        auto: 'format,compress',
                        fit: 'crop',
                        ar: '1:1'
                        }"/>

                <p class="mt-6 mb-0">
                    {{hoverItem.title}}
                </p>
                <!-- Read full story excerpt-->
                <p class="custom-p mt-0">
                {{ hoverItem.excerpt }}
                </p>
            </NuxtLink>
        </template>
        <!-- P A G E -->
        <template v-if="hovertype === 'PAGE'">
            <NuxtLink :to="url === '/my-gravaa' ? 'https://gravaa.myshopify.com/account' : url">
            <transition name="fade-in">
                <div>
                    <MenuHoverMediaImage v-if="hoverItem.coverImage" :mediaData="hoverItem.coverImage.reference" :alt="hoverItem.title" :imagetype="hovertype.toLowerCase()"/>
                </div>
            </transition>
            <p class="mt-6 mb-0" v-html="hoverItem.bodySummary"/>
                <p
                v-if="secondary"
                class="block mt-0 custom-p"
                v-html="hoverItem.menudescription?.value "
                />
            </NuxtLink>
        </template>

        <!--B L O G -->
        <template v-if="hovertype === 'BLOG'">
            <NuxtLink :to="url">
            <transition name="fade-in">
                <MenuHoverMediaImage v-if="hoverItem.coverImage" :mediaData="hoverItem.coverImage.reference" :alt="hoverItem.title" :imagetype="hovertype.toLowerCase()"/>
            </transition>
            <p class="mt-6">
                {{hoverItem.title}}
            </p>
            </NuxtLink>
        </template>
    </div>
</template>

<script setup>
import { useImageUtils } from '@/composables/useImageUtils';
const { extractImageFromPageBody, toImgixPath} = useImageUtils();

const props = defineProps({

    hoverItem: {
        type: Object,
        required: true
    },
    hovertype: {
        type: String,
        required: true
    },
    url: {
        type: String,
        required: false
    },
    secondary: {
        type: Boolean,
        default: false
    }
});


</script>

<style scoped>
@reference "../../assets/css/main.css";
/* Your component styles go here */


</style>
